import {
  useQuery,
  type UseQueryOptions,
  type UseQueryResult,
} from '@tanstack/react-query';

import { conns } from '@cfg/axiosConfig.tsx';
import type { ImageMinimumInfo } from '@app-types/commons/images.types.ts';

export interface PosPaymentMethod {
  id: number;
  name: string;
  code?: string | null;
  description?: string | null;
  provider: string;
  is_active: boolean;
  fee_percent?: number | null;
  fee_fixed?: number | null;
  settlement_days?: number | null;
  cash_box_id?: number | null;
  image?: ImageMinimumInfo | null;
  settings?: Record<string, unknown> | null;
}

const fetchPosPaymentMethods = async (): Promise<PosPaymentMethod[]> => {
  const { data } = await conns<PosPaymentMethod[]>('erp:payment:methods').get();
  return data;
};

export type PosPaymentMethodsQueryOptions<TData> = Omit<
  UseQueryOptions<PosPaymentMethod[], Error, TData>,
  'queryKey' | 'queryFn'
>;

export const usePosPaymentMethods = <TData = PosPaymentMethod[]>(
  options?: PosPaymentMethodsQueryOptions<TData>,
): UseQueryResult<TData, Error> => {
  return useQuery<PosPaymentMethod[], Error, TData>({
    queryKey: ['pos', 'payment-methods'],
    queryFn: fetchPosPaymentMethods,
    staleTime: 30_000,
    ...options,
  });
};

export { fetchPosPaymentMethods };
